// extracted by mini-css-extract-plugin
export var container = "_66-0";
export var disabled = "_66-4";
export var fullWidth = "_66-3";
export var lined = "_66-1";
export var selected = "_66-5";
export var tab = "_66-2";